import * as Sentry from '@sentry/react';
import { API_DOMAIN } from 'consts';
import { security } from 'shared';
import { toast } from 'sonner';

export const SALES_EMAIL = 'sales@hiloanalytics.com';

/**
 * Ask sales to get in touch, from any of the upgrade modals.
 *
 * Replaces a mailto: the user no longer needs a configured mail client, and
 * the request is recorded server-side instead of vanishing into their drafts.
 *
 * Fire-and-forget by design — the modal has already closed by the time this
 * runs, so the toast is the only feedback. A failure must name the address to
 * write to, otherwise the user is left thinking sales has their details when
 * nothing was sent.
 */
export async function submitUpgradeRequest (): Promise<void> {
  try {
    const token = await security.getAccessTokenSilently()();
    const response = await fetch(`${API_DOMAIN}/api/users/request-upgrade`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      throw new Error(`request-upgrade returned ${response.status}`);
    }
    toast.success('Thanks — the HiLo team will reach out to you shortly.');
  } catch (err) {
    // A lost lead is invisible otherwise: the user sees a toast, but nobody
    // on our side knows the request never arrived.
    Sentry.captureException(err, { tags: { op: 'upgrade.request' } });
    toast.error(`We couldn't send your request. Please email ${SALES_EMAIL}.`);
  }
}
